import {ErrorHandler, Injectable, NgZone} from '@angular/core';
import {LoggerService} from './services/logger.service';

@Injectable()
export class CustomErrorHandlerService extends ErrorHandler {

    private loggedErrors = [];

    constructor(private loggerService: LoggerService,
                private zone: NgZone) {
        super();
    }

    override handleError(error) {
        const errorText = JSON.stringify(error?.stack || error?.message);
        if (this.loggedErrors.indexOf(errorText) === -1) {
            this.zone.run(() => {
                console.log(error);
                this.loggerService.logError(error?.stack || error?.message);
            });
            this.loggedErrors.push(errorText);
            setTimeout(() => {
                this.loggedErrors.splice(this.loggedErrors.indexOf(errorText), 1);
            }, 1000 * 60 * 5);
        }

        super.handleError(error);
    }
}
